// extracted by mini-css-extract-plugin
export var header = "index-module--header--3QLVR";
export var header_solid = "index-module--header_solid--Nsj9O";
export var logo = "index-module--logo--G8cLS";
export var nav = "index-module--nav--1RFRA";
export var nav_item = "index-module--nav_item--3vwVN";